import React from 'react';
import '../../../App.css';
import CircleNum from './CircleNum';


const CircleNumP = ({
    children,
    num
}) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start' }}>
            <CircleNum>{num}</CircleNum>
            <p>{children}</p>
        </div>
    );
};

export default CircleNumP;